import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=none, obj=user

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password, code) => {
    const { data } = await api.post("/auth/login", { email, password, code });
    setUser(data);
    return data;
  };

  const pinLogin = async (username, pin, device_id) => {
    const { data } = await api.post("/auth/pin-login", { username, pin, device_id });
    localStorage.setItem("patria_device", device_id);
    localStorage.setItem("patria_campus", data.campus_id || "");
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, pinLogin, logout, refresh, apiError }}>
      {children}
    </AuthContext.Provider>
  );
}
